export default "__VITE_ASSET__CT0inV4s__"